import {useTranslation} from "react-i18next";
import Accordion from "../../../../../../../../components/blocks/Accordion";
import AccordionItem from "../../../../../../../../components/blocks/Accordion/AccordionItem";
import FormInput from "../../../../../../../../components/blocks/FormInput";
import DatePicker from "../../../../../../../../components/blocks/DatePicker";
import AttachmentCard from "../../../../../../../../components/blocks/AttachmentCard";
import {CourseOrderLocalItemResult} from "../../../../../../../../services/courseOrder/models/CourseOrderType";

export const ISBNSection = ({ order }: { order: CourseOrderLocalItemResult | null }) => {
    const { t } = useTranslation("Orders");
if(order?.isbn || order?.isbnFiles?.length)
    return (
        <Accordion>
            <AccordionItem initiallyOpen title={t("PublishingHouse")} elementId={"PublishingHouse"}>
                <div className="d-flex gap-2 flex-wrap">
                    <FormInput
                        label={t("rdmk")}
                        disabled
                        value={order?.isbn}
                    />
                    <DatePicker value={order?.isbnRequestedDate} label={t("rdmkRequestDate")} disabled />
                </div>

                <div className="pt-4">
                    <h6 className="fw-bold">{t("attachments")}</h6>
                    <div className="d-flex gap-3 mt-2 ">
                        {order?.isbnFiles?.length ? (
                            order?.isbnFiles?.map((attachment) => (
                                <AttachmentCard
                                    key={attachment.id}
                                    attachment={{
                                        id: attachment.id,
                                        fileName: attachment.name ?? "",
                                        size: attachment.size ?? "",
                                        extension: attachment.extension ?? "",
                                    }}
                                />
                            ))
                        ) : (
                            <span>{t("Common:noData")}</span>
                        )}
                    </div>
                </div> 
                <div className="pt-4">
                <h6 className="fw-bold">{t("AttachContract")}</h6>
                    <div className="d-flex gap-3 mt-2 ">
                        <>
                        {order?.isbnContract && 
                                <AttachmentCard
                                    key={order?.isbnContract.id}
                                    attachment={{
                                        id: order?.isbnContract.id,
                                        fileName: order?.isbnContract.name ?? "",
                                        size: order?.isbnContract.size ?? "",
                                        extension: order?.isbnContract.extension ?? "",
                                    }}
                                />
                        }
                            {!order?.isbnContract &&
                                <span>{t("Common:noData")}</span>
                            }
                            </>
                    </div>
                </div>

                <div className="divider mt-4 "></div>
            </AccordionItem>
        </Accordion>
    );
else return <></>;
};
